import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ISiteSAMLConfiguration } from '../types/ISiteSAMLConfiguration';

export interface ISetSiteSAMLAuthSettingForEmbeddedViewsParams {
  authSetting: string;
}

export class SetSiteSAMLAuthSettingForEmbeddedViewsRequest extends Request<ISetSiteSAMLAuthSettingForEmbeddedViewsParams, ISiteSAMLConfiguration> {
  constructor(params: ISetSiteSAMLAuthSettingForEmbeddedViewsParams) {
    super('setSiteSAMLAuthSettingForEmbeddedViews', params);
  }
}
